// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("flaticon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("flaticon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("flaticon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("flaticon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Flaticon";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
    font-weight: normal;
    font-style: normal;
}
.flaticon {
    display:inline-block;
    font:normal normal normal 14px/1 Flaticon;
    font-size:inherit;
}
.flaticon-cube:before {
    content: "\\e000";
}
.flaticon-cube8:before {
    content: "\\e001";
}
.flaticon-delivery27:before {
    content: "\\e002";
}
.flaticon-excavator6:before {
    content: "\\e003";
}
.flaticon-file257:before {
    content: "\\e004";
}
.flaticon-folding:before {
    content: "\\e005";
}
.flaticon-graphicseditor7:before {
    content: "\\e006";
}
.flaticon-minus10:before {
    content: "\\e007";
}
.flaticon-multimediaoption193:before {
    content: "\\e008";
}
.flaticon-rotate8:before {
    content: "\\e009";
}
.flaticon-ruler13:before {
    content: "\\e00a";
}
.flaticon-software9:before {
    content: "\\e00b";
}
.flaticon-square37:before {
    content: "\\e00c";
}
.flaticon-write19:before {
    content: "\\e00d";
}
.flaticon-writing131:before {
    content: "\\e00e";
}
.flaticon-writing132:before {
    content: "\\e00f";
}
`, "",{"version":3,"sources":["webpack://./assets/fonts/flaticon/flaticon.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,4CAAwB;IACxB;;;yDAGiC;IACjC,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,oBAAoB;IACpB,yCAAyC;IACzC,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["@font-face {\n    font-family: \"Flaticon\";\n    src: url(\"flaticon.eot\");\n    src: url(\"flaticon.eot#iefix\") format(\"embedded-opentype\"),\n    url(\"flaticon.woff\") format(\"woff\"),\n    url(\"flaticon.ttf\") format(\"truetype\"),\n    url(\"flaticon.svg\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n}\n.flaticon {\n    display:inline-block;\n    font:normal normal normal 14px/1 Flaticon;\n    font-size:inherit;\n}\n.flaticon-cube:before {\n    content: \"\\e000\";\n}\n.flaticon-cube8:before {\n    content: \"\\e001\";\n}\n.flaticon-delivery27:before {\n    content: \"\\e002\";\n}\n.flaticon-excavator6:before {\n    content: \"\\e003\";\n}\n.flaticon-file257:before {\n    content: \"\\e004\";\n}\n.flaticon-folding:before {\n    content: \"\\e005\";\n}\n.flaticon-graphicseditor7:before {\n    content: \"\\e006\";\n}\n.flaticon-minus10:before {\n    content: \"\\e007\";\n}\n.flaticon-multimediaoption193:before {\n    content: \"\\e008\";\n}\n.flaticon-rotate8:before {\n    content: \"\\e009\";\n}\n.flaticon-ruler13:before {\n    content: \"\\e00a\";\n}\n.flaticon-software9:before {\n    content: \"\\e00b\";\n}\n.flaticon-square37:before {\n    content: \"\\e00c\";\n}\n.flaticon-write19:before {\n    content: \"\\e00d\";\n}\n.flaticon-writing131:before {\n    content: \"\\e00e\";\n}\n.flaticon-writing132:before {\n    content: \"\\e00f\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
